/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    search({commit}, payload) {
        return new Promise((resolve) => {

            let query = '?q=' + payload.query;

            axios({url: state.API_URL + '/auth/search/' + payload.lang_id + '/'+ query, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                })
        })
    },
};
